import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../../../base.component';
import { AddressesService } from '../../../../Services/addresses/Addresses';

@Component({
	selector: 'app-address-display-dr',
	templateUrl: './address-display-dr.component.html',
	styleUrls: ['./address-display-dr.component.scss'],
})
export class AddressDisplayDrComponent extends BaseComponent implements OnInit {
	isShowAddressDisplay: boolean = true;

	constructor(injector: Injector, private Addresses: AddressesService) {
		super(injector);
	}

	ngOnInit() {
		this.Addresses.showEditAddressReplaySubject.subscribe((isShow: boolean) => {
			const elem = this.elementRef.nativeElement.parentElement.parentElement.parentElement.parentElement;
			this.isShowAddressDisplay = !isShow;
			if (this.isShowAddressDisplay) {
				this.Renderer.setStyle(elem, 'display', 'block');
			} else {
				this.Renderer.setStyle(elem, 'display', 'none');
			}
			if (this.control && this.control.attributes && this.control.attributes.InValidAddress && !isShow) {
				this.Addresses.showEditAddressReplaySubject.next(true);
			}
		});
	}

	onEditAddressClick(): void {
		const dataObjEdit = {
			event: 'GAEvent',
			route: window.location.pathname,
			eventCategory: 'Home_Quoting',
			eventAction: 'ButtonClick',
			CurrentItemNameInHTML: '',
			DesiredItemNameinHTML: 'Address_Edit',
			eventLabel: 'Address_Edit',
			eventValue: '',
			callback: '',
			nonInteraction: 'nonInteraction',
		};

		const dataObjDisplay = {
			event: 'GAEvent',
			route: window.location.pathname,
			eventCategory: 'Home_Quoting',
			eventAction: 'Display',
			CurrentItemNameInHTML: '',
			DesiredItemNameinHTML: 'Popup.ConfirmAddress_Displayed',
			eventLabel: 'Popup.ConfirmAddress_Displayed',
			eventValue: '',
			callback: '',
			nonInteraction: 'nonInteraction',
		};

		this.isShowAddressDisplay = false;
		const elem = this.elementRef.nativeElement.parentElement.parentElement.parentElement.parentElement;
		if (this.isShowAddressDisplay) {
			this.Renderer.setStyle(elem, 'display', 'block');
		} else {
			this.Renderer.setStyle(elem, 'display', 'none');
		}

		this.Addresses.showEditAddressReplaySubject.next(true);
	}
}
